module.exports = __webpack_public_path__ + "static/media/checkbox-answer-checked-wrong.0fc4c47e.svg";